import React from "react";
import PropertyCard from "./PropertyCard";
import { Skeleton } from "@mui/material";
import {
  MapWrapper,
  PropertyListMapWrapper,
  PropertyListWrapper,
  ToggleBoxesWrapper,
  TogglesWrapper,
  Wrapper,
} from "./styles";

function PropertiesListSkeleton() {
  return (
    <Wrapper>
      <Skeleton variant="rectangular" width="200px" height="24px" />
      <Skeleton variant="rectangular" width="150px" height="16px" />
      <Skeleton variant="rectangular" width="300px" height="32px" />
      <TogglesWrapper>
          <Skeleton variant="rectangular" width="120px" height="32px" />
        <ToggleBoxesWrapper>
          <Skeleton variant="rectangular" width="32px" height="32px" />
          <Skeleton variant="rectangular" width="32px" height="32px" />
        </ToggleBoxesWrapper>
      </TogglesWrapper>
      {/* if (loading === true) return "Buscando os imóveis..."; */}
      <PropertyListMapWrapper>
        <PropertyListWrapper>
          <PropertyCard />
          <PropertyCard />
          <PropertyCard />
          <PropertyCard />
          <PropertyCard />
          <PropertyCard />
          <PropertyCard />
          <PropertyCard />
          <PropertyCard />
          <PropertyCard />
        </PropertyListWrapper>
        <MapWrapper>
          <Skeleton style={{flex: 1}} variant="rectangular" height="100%" />
        </MapWrapper>
      </PropertyListMapWrapper>
    </Wrapper>
  );
}

export default PropertiesListSkeleton;
